import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class LoaderService {
	private loaderSubject = new BehaviorSubject<boolean>(false);

	loaderState = this.loaderSubject.asObservable().pipe(distinctUntilChanged());
	runningRequests = 0;

	constructor() {}

	show() {
		this.runningRequests++;
		this.loaderSubject.next(true);
	}

	hide() {
		this.runningRequests--;
		if (this.runningRequests > 0) return;
		this.loaderSubject.next(false);
	}
}
